import React, {useEffect} from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import {css} from '@emotion/react';
import {mobile, tablet, desktop} from '~styles/global';
import {useInView} from 'react-intersection-observer';
import Image from '~components/Image';
import Section from '~components/Section';
import Video from '~components/Video';
import useBreakpoint from '~utils/useBreakpoint';
import resolveLink from '~utils/resolveLink';
import {Link} from 'gatsby';

const Slide = ({className, project, i, onChange}) => {
	const {isMobile} = useBreakpoint();
	const [ref, inView] = useInView({threshold: isMobile ? 1 : 0.51});

	useEffect(() => {
		if (inView && onChange) {
			onChange(i);
		}
	}, [inView, onChange]);

	return (
		<div className={className} ref={ref}>
			<Wrap>
				<Thumbnail to={resolveLink(project)}>
					<Height>
						{project?.thumbnail === null && <Placeholder active={inView} />}
						{project?.thumbnail?.mediaType === 'video' ? <StyledVideo src={project?.thumbnail?.video?.video?.asset?.url} /> : <StyledImage image={project?.thumbnail?.image} cover />}
					</Height>
				</Thumbnail>
			</Wrap>
		</div>
	);
};

const Wrap = styled(Section)`
	height: 100vh;
	> div {
		height: 100vh;
		align-items: center;
	}
`;
const Thumbnail = styled(Link)`
	grid-column: span 12;
	/* max-width: 916px; */
	/* height: 572px; */
	margin: 0 auto;
	width: 130vh;
	max-width: calc(100svw - 60px);
`;
const Height = styled.div`
	margin: 0 auto;
	width: 100%;
	position: relative;
	height: 0;
	padding-bottom: 58.158%;
`;
const StyledVideo = styled(Video)`
	width: 100%;
	height: 100%;
	object-fit: cover;
	position: absolute;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
`;
const StyledImage = styled(Image)`
	width: 100%;
	height: 100%;
	object-fit: cover;
	position: absolute;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
`;
const Placeholder = styled.div`
	width: 100%;
	background-color: ${(props) => (props.active ? 'red' : 'blue')};
	height: 400px;
	height: 0px;
	padding-bottom: 62.5%;
`;
Slide.propTypes = {
	className: PropTypes.string,
	project: PropTypes.object,
	i: PropTypes.number,
	onChange: PropTypes.func,
};
export default Slide;
